module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kanagawa-2-c7142054ebeabb1f02f58e9eb32b6b9d.png";